import React from "react";
import styled from "@emotion/styled";


const MaskContainer = styled.div`
    cursor: progress;
`;
const MaskContainerMobile = styled.div`
    cursor: progress;
    z-index: 100000;
    opacity: 0.5;
    background: #fff;
`;
export class Mask extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render(){
        const {mobile} = this.props;
        if (mobile) { 
            return(
                <MaskContainerMobile className="z-index-2 width-100 height-100 absolute top-0 left-0 border-radius-default" />
            );
        } else {
            return(
                <MaskContainer
                    className="z-index-2 width-100 height-100 absolute top-0 left-0 border-radius-default"
                /> 
            );
        }
    }
}


